export const areaOverviewTranslations = {
  performance: {
    buttonLabel: {
      key: 'areaOverview.performance.buttonLabel',
      defaultValue: 'Performance',
    },
    drawerTitle: {
      key: 'areaOverview.performance.drawerTitle',
      defaultValue: 'Area Performance',
    },
  },
  salesOverview: {
    title: {
      key: 'areaOverview.salesOverview.title',
      defaultValue: 'Sales Overview',
    },
    headerText: {
      key: 'areaOverview.salesOverview.headerText',
      defaultValue: 'Total Sales',
    },
    widgetText: {
      key: 'areaOverview.salesOverview.widgetText',
      defaultValue:
        'Displays total sales across the area, including Regular Sales and SCO Sales, providing a clear view of overall sales performance.',
    },
    regularSalesText: {
      key: 'areaOverview.salesOverview.regularSalesText',
      defaultValue: 'Regular Sales',
    },
    scoSalesText: {
      key: 'areaOverview.salesOverview.scoSalesText',
      defaultValue: 'SCO Sales',
    },
  },
  memberOverview: {
    title: {
      key: 'areaOverview.memberOverview.title',
      defaultValue: 'Member Overview',
    },
    headerText: {
      key: 'areaOverview.memberOverview.headerText',
      defaultValue: 'Total Member Transactions',
    },
    widgetText: {
      key: 'areaOverview.memberOverview.widgetText',
      defaultValue:
        'Highlights new members, member revenue share, unrecruited percentage, and self-checkout share of receipts',
    },
    memberSorText: {
      key: 'areaOverview.memberOverview.memberSorText',
      defaultValue: 'Member SoR',
    },
    scoSorText: {
      key: 'areaOverview.memberOverview.scoSorText',
      defaultValue: 'SCO SoR',
    },
  },
  conversionRateOverview: {
    title: {
      key: 'areaOverview.conversionRateOverview.title',
      defaultValue: 'Conversion Rate Overview',
    },
    headerText: {
      key: 'areaOverview.conversionRateOverview.headerText',
      defaultValue: 'Conversion Rate',
    },
    widgetText: {
      key: 'areaOverview.conversionRateOverview.widgetText',
      defaultValue:
        'This widget displays conversion rate, utilized tills, demand tills, and total visitors for quick performance insights.',
    },
    utilisedTillsText: {
      key: 'areaOverview.conversionRateOverview.utilisedTillsText',
      defaultValue: 'Utilised Tills',
    },
    totalVisitorsText: {
      key: 'areaOverview.conversionRateOverview.totalVisitorsText',
      defaultValue: 'Total Visitors',
    },
  },
  efficiencyOverview: {
    title: {
      key: 'areaOverview.efficiencyOverview.title',
      defaultValue: 'Efficiency Overview',
    },
    headerText: {
      key: 'areaOverview.efficiencyOverview.headerText',
      defaultValue: 'Effective Hours',
    },
    widgetText: {
      key: 'areaOverview.efficiencyOverview.widgetText',
      defaultValue:
        'Tracks productivity metrics: Sales Net, Sold Pieces, Effective Hours, excluding absences, measuring efficiency and performance.',
    },
    takt1Text: {
      key: 'areaOverview.efficiencyOverview.takt1Text',
      defaultValue: 'Takt 1',
    },
    sptText: {
      key: 'areaOverview.efficiencyOverview.sptText',
      defaultValue: 'SPT',
    },
  },
  queueCustomerOverview: {
    title: {
      key: 'areaOverview.queueCustomerOverview.title',
      defaultValue: 'Queue & Customer Overview',
    },
    headerText: {
      key: 'areaOverview.queueCustomerOverview.headerText',
      defaultValue: 'Overall Queue Length',
    },
    widgetText: {
      key: 'areaOverview.queueCustomerOverview.widgetText',
      defaultValue:
        'Shows queue length, customer satisfaction, and engagement to gauge service performance and overall customer experience.',
    },
    customerSatisfactionText: {
      key: 'areaOverview.queueCustomerOverview.customerSatisfactionText',
      defaultValue: 'Customer Satisfaction',
    },
    customerEngagementText: {
      key: 'areaOverview.queueCustomerOverview.customerEngagementText',
      defaultValue: 'Customer Engagement',
    },
  },
  rfidOverview: {
    title: {
      key: 'areaOverview.rfidOverview.title',
      defaultValue: 'RFID Overview',
    },
    widgetText: {
      key: 'areaOverview.rfidOverview.widgetText',
      defaultValue:
        'This widget tracks RFID approval rates, sales, retagging, count, time spent, device usage and stock accuracy.',
    },
    negativeApprovalRateText: {
      key: 'areaOverview.rfidOverview.negativeApprovalRateText',
      defaultValue: 'Negative Approval Rate',
    },
    positiveApprovalRateText: {
      key: 'areaOverview.rfidOverview.positiveApprovalRateText',
      defaultValue: 'Positive Approval Rate',
    },
    rfidSalesText: {
      key: 'areaOverview.rfidOverview.rfidSalesText',
      defaultValue: 'RFID Sales',
    },
    retaggingRateText: {
      key: 'areaOverview.rfidOverview.retaggingRateText',
      defaultValue: 'Retagging Rate',
    },
    rfidCountText: {
      key: 'areaOverview.rfidOverview.rfidCountText',
      defaultValue: 'RFID Count',
    },
    timeSpentText: {
      key: 'areaOverview.rfidOverview.timeSpentText',
      defaultValue: 'Time Spent',
    },
    deviceUsageText: {
      key: 'areaOverview.rfidOverview.deviceUsageText',
      defaultValue: 'Devices',
    },
    stockAccuracyText: {
      key: 'areaOverview.rfidOverview.stockAccuracyText',
      defaultValue: 'Stock Accuracy',
    },
  },
  budgetPlanOverview: {
    title: {
      key: 'areaOverview.budgetPlanOverview.title',
      defaultValue: 'Budget/Plan Overview',
    },
    widgetText: {
      key: 'areaOverview.budgetPlanOverview.widgetText',
      defaultValue: 'A widget for real-time budget tracking, planning, and performance monitoring.',
    },
  },
  kpiOverview: {
    title: {
      key: 'areaOverview.kpiOverview.title',
      defaultValue: 'KPI and Forecast Overview',
    },
    widgetText: {
      key: 'areaOverview.kpiOverview.widgetText',
      defaultValue: 'Real-time KPIs tracking sales, revenue, engagement with customizable charts.',
    },
  },
  summaryWidgetsOverview: {
    title: {
      key: 'areaOverview.summaryWidgetsOverview.title',
      defaultValue: 'Summary Widgets Overview',
    },
    kpis: {
      key: 'areaOverview.summaryWidgetsOverview.kpis',
      defaultValue: 'KPIs',
    },
    kpisDescription: {
      key: 'areaOverview.summaryWidgetsOverview.kpisDescription',
      defaultValue: 'The numberof KPIs are set in all the stores from that area.',
    },
    totalTransactions: {
      key: 'areaOverview.summaryWidgetsOverview.totalTransactions',
      defaultValue: 'Total transactions',
    },
    totalTransactionsDescription: {
      key: 'areaOverview.summaryWidgetsOverview.totalTransactionsDescription',
      defaultValue: 'Sales and combination of Sale/Return transactions in all the stores from that area.',
    },
    totalNewMembers: {
      key: 'areaOverview.summaryWidgetsOverview.totalNewMembers',
      defaultValue: 'Total new members',
    },
    totalNewMembersDescription: {
      key: 'areaOverview.summaryWidgetsOverview.totalNewMembersDescription',
      defaultValue: 'New members in all the stores from that area.',
    },
    totalDiscountedTransactions: {
      key: 'areaOverview.summaryWidgetsOverview.totalDiscountedTransactions',
      defaultValue: 'Total discounted transactions',
    },
    totalDiscountedTransactionsDescription: {
      key: 'areaOverview.summaryWidgetsOverview.totalDiscountedTransactionsDescription',
      defaultValue: 'Total number of transactions with discounts in all the stores from that area.',
    },
    totalSoldPieces: {
      key: 'areaOverview.summaryWidgetsOverview.totalSoldPieces',
      defaultValue: 'Total sold Pieces',
    },
    totalSoldPiecesDescription: {
      key: 'areaOverview.summaryWidgetsOverview.totalSoldPiecesDescription',
      defaultValue: 'Sold pieces in all the stores from that area.',
    },
    totalReturnedPieces: {
      key: 'areaOverview.summaryWidgetsOverview.totalReturnedPieces',
      defaultValue: 'Total returned pieces',
    },
    totalReturnedPiecesDescription: {
      key: 'areaOverview.summaryWidgetsOverview.totalReturnedPiecesDescription',
      defaultValue: 'Returned pieces in all the stores from that area.',
    },
    highlightedWidgets: {
      key: 'areaOverview.summaryWidgetsOverview.highlightedWidgets',
      defaultValue: 'Highlighted Widgets',
    },
    highlightedWidgetsDescription: {
      key: 'areaOverview.summaryWidgetsOverview.highlightedWidgetsDescription',
      defaultValue: 'Highlighted widgets for all stores within an area.',
    },
  },
};
